import { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { partition } from 'lodash';
import { DataItemFormatter } from '@creditsights/styleguide-web';
import { FilterDto, FilterType } from '../../../../../../models/Filter';
import { getSectorDisplayName } from './PreferenceTypesRenderer.logic';
import styles from './PreferenceTypesRenderer.module.scss';

const cx = classNames.bind(styles);

const PreferenceTypesRenderer: DataItemFormatter<string[], ReactElement, { tags: FilterDto[] }> = ({
  value: preferenceTagIds,
  props,
}: {
  value: string[];
  props?: { tags: FilterDto[] };
}) => {
  const [sectorTags, otherTags] = partition(props?.tags, (tagFilter) => tagFilter.type === FilterType.sector);
  const otherTagItems = otherTags.flatMap((t) => t.options);

  const preferenceTypes = preferenceTagIds.map((tagId) => {
    const displayName = tagId.startsWith(FilterType.sector)
      ? getSectorDisplayName(tagId, sectorTags[0].options)
      : otherTagItems.find((tag) => tag.tagId === tagId)?.displayName;

    return displayName;
  });

  return (
    <div className={cx('body')}>
      {preferenceTypes.map((preferenceType, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={cx('preference')} key={i}>
          {preferenceType}
        </div>
      ))}
    </div>
  );
};

export default PreferenceTypesRenderer;
